<template>
  <div class="project-card">
    <div class="project-card-content">
      <div class="logo-and-address">
        <div class="logo-img">
<!--          <fa :icon="['fadr', 'house-building']" size="3x" style="color: #000"></fa>-->
          <fa :icon="['fadr', 'house-building']" size="3x" style="color: #5AA0FF"></fa>
<!--          <fa :icon="['fas', 'house-building']" size="2xl" style="color: #2f4c39"></fa>-->
<!--          <fa :icon="['fas', 'pencil-ruler']" size="2xl" style="color: #5AA0FF"></fa>-->
<!--          <img :src="iconForCard" alt="Logo Image">-->
        </div>
        <div class="project-address">
          <template
              v-if="projectAddress.line1 || projectAddress.line2 || projectAddress.town || projectAddress.postcode">
            {{ projectAddress.line1 }}<span v-if="projectAddress.line1 && projectAddress.line2">,</span>
            {{ projectAddress.line2 }}<span v-if="projectAddress.line2 && projectAddress.town">,</span>
            {{ projectAddress.town }}<span v-if="projectAddress.town && projectAddress.postcode">,</span>
            {{ projectAddress.postcode }}
          </template>
          <template v-else>
            No address provided
          </template>
        </div>
      </div>
      <div class="content">
        <div class="project-state">Current State: {{ serviceState | title }}</div>
        <div class="project-total">Client Total (Ex Vat):
          {{ projectTotal | currencyNotReduced }}
        </div>
      </div>
      <div class="project-card-identifier">{{ projectDetails.ref }}</div>
    </div>
  </div>
</template>

<script>
import filters from 'module/filters';

export default {
  name: 'project-card',
  filters,
  components: {},
  props: {
    projectDetails: {
      type: Object,
      required: true,
    },
    iconType: {
      type: String,
      default: 'standard',
    },
  },
  data() {
    return {};
  },
  computed: {
    iconForCard() {
      switch (this.iconType) {
        case 'pce':
          return 'img/pce-logo-image.png';
        case 'standard':
        default:
          return 'img/project-estimator-logo-icon.svg';
      }
    },
    projectAddress() {
      let projectAddress = {};
      projectAddress.line1 = _.get(this.projectDetails, 'projectAddress.line1', null);
      projectAddress.line2 = _.get(this.projectDetails, 'projectAddress.line2', null);
      projectAddress.town = _.get(this.projectDetails, 'projectAddress.town', null);
      projectAddress.postcode = _.get(this.projectDetails, 'projectAddress.postcode', null);

      return projectAddress;
    },
    serviceState() {
      if (_.get(this.projectDetails, 'servicesForProject', []).length === 0) {
        return 'Self-Estimated';
      }

      if (_.get(this.projectDetails, 'state.byWorkflow.quantityTakeOff', null) !== null) {
        return _.get(this.projectDetails, 'state.byWorkflow.quantityTakeOff', null)
      }

      return 'No take-off';
    },
    projectTotal() {
      return _.get(this.projectDetails, 'plotsSummary.totals.estimate.clientTotalExVat', 0);
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>

.project-card {
  font-family: 'Roboto', sans-serif;
  border-radius: 0.5rem;
  transition: all 0.2s ease-in-out;
  background-color: $primary;
  overflow: hidden;
  @include box-shadow(2px 2px 10px rgba(0, 0, 0, 0.6));

  @media only screen and (min-width: $tablet--large) {
    height: 226px;
  }

  &:hover {
    transform: translateY(-2px);
    background-color: $secondary;
  }

  .project-card-content {
    padding: 20px;
    border-radius: 0.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;

    .logo-and-address {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      gap: 15px;

      .logo-img {
        @include phone {
          display: none;
        }
      }

      .project-address {
        color: $primary-font-color;
        font-size: 1.25rem;
        font-weight: 600;
        letter-spacing: 0.05em;
      }
    }

    .content {
      color: $primary-font-color;
      display: flex;
      flex-direction: column;
      gap: 0.1em;
      margin-top: 1em;
      margin-bottom: 0;

      .project-state,
      .project-total {
        font-size: 1.1rem;
        font-weight: 600;
      }
    }

    .project-card-identifier {
      color: $accent;
      align-self: flex-end;
      justify-self: flex-end;
      font-size: 1rem;
      font-weight: 400;
      letter-spacing: 0.03em;
    }
  }

  @media screen and (min-width: 768px) {
    width: 100%;
  }
}
</style>